import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MonitorInterceptor } from "./monitor.interceptor";
import { ValidatorInterceptorService } from "./validator-interceptor.service";

export const interceptorProviders = 
   [
    { provide: HTTP_INTERCEPTORS, useClass: ValidatorInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MonitorInterceptor, multi: true },
   ]